import { render, staticRenderFns } from "./CustomerTypes.vue?vue&type=template&id=2e821f58&"
import script from "./CustomerTypes.vue?vue&type=script&lang=js&"
export * from "./CustomerTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports